/**
 * Validate the email of the user
 * @param email - The email of the user
 * @returns true if the email is valid, false otherwise
 */
export function validateEmail(email: string): boolean {
  // Please provide a valid email.
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
  return emailRegex.test(email)
}

/**
 * Validate the password of the user
 * @param password - The password of the user
 * @returns true if the password is valid, false otherwise
 */
export function validatePassword(password: string): boolean {
  // Please provide a valid password. Password must be at least 8 characters long and contain at least one uppercase letter and one special character.
  const passwordRegex = /^(?=.*[A-Z])(?=.*[^a-zA-Z0-9]).{12,}$/
  return passwordRegex.test(password)
}

/**
 * Validate the name of the user
 * @param name - The name of the user
 * @returns true if the name is valid, false otherwise
 */
export function validateUserName(name: string): boolean {
  // Allow letters, numbers, spaces, hyphens, and apostrophes, 2-50 characters
  // Please provide a valid name. Name can only have the following characters: _, ., -, a-z, A-Z, 0-9 and spaces
  const nameRegex = /^[a-zA-Z0-9\s\-']{2,50}$/
  return nameRegex.test(name)
}

/**
 * Validate the organization name
 * @param name - The name of the organization
 * @returns true if the name is valid, false otherwise
 */
export function validateOrganizationName(name: string): boolean {
  // Allow letters, numbers, spaces, hyphens, and apostrophes, 2-50 characters
  // Please provide a valid name. Name can only have the following characters: _, ., @, &, -, a-z, A-Z, 0-9 and spaces
  const nameRegex = /^[a-zA-Z0-9\s\-'&@]{2,50}$/
  return nameRegex.test(name)
}

/**
 * Validate a system name with spaces
 * @param name - The name of the intent
 * @returns true if the name is valid, false otherwise
 */
export function validateSystemName(name: string): boolean {
  // Allow letters, numbers, hyphens, and apostrophes, 2-30 characters
  // Please provide a valid name. Names can only have the following characters: _, ., -, a-z, A-Z, 0-9 and spaces
  const nameRegex = /^[a-zA-Z0-9\s\-']{2,50}$/
  return nameRegex.test(name)
}

/**
 * Validate a system name without spaces
 * @param name - The name of the intent
 * @returns true if the name is valid, false otherwise
 */
export function validateSystemNameNoSpaces(name: string): boolean {
  // Allow letters, numbers, underscores, 2-50 characters
  // Please provide a valid name. Names can only have the following characters: a-z, A-Z, 0-9, _
  const nameRegex = /^[a-zA-Z0-9_]{2,50}$/
  return nameRegex.test(name)
}

/**
 * Validate if a value is a string and not empty
 * @param name - The name of the intent
 * @returns true if the name is valid, false otherwise
 */
export function validateStringOnly(name: string): boolean {
  //check if value is a string and not empty
  return typeof name === "string" && name.trim() !== ""
}

/**
 * Validate if a value is a valid url pattern (used for injecting urls into the system)
 * @param url - The url to validate
 * @returns true if the url is valid, false otherwise
 */
export function validateUrlPatern(url: string): boolean {
  // Check for valid url
  const urlRegex = /(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/
  return urlRegex.test(url)
}
